import React, { useEffect, useState } from "react";
import "./index.less";
import { Row, Col, Button, Spin } from "antd";
import { ReactComponent as BackIcon } from "../../assets/back-icon.svg";
import DocumentTable from "./DocumentTable";
import { useSelector } from "react-redux";

const DefaultDocument = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.default_doc_fields?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div heading-parent-div">
      <Row justify="space-between">
        <Col>
          <span className="text-span">Edit Default Document Fields</span>
        </Col>
      </Row>
      <DocumentTable canUpdate={canUpdate} />
    </div>
  );
};

export default DefaultDocument;
